<template>
  <b-container v-if="imageUrl">
    <b-row>
      <b-col>
        <img :src="imageUrl" :alt="imageAlt" class="image img-fluid" loading="lazy" />
      </b-col>

      <b-col v-if="title || text || (buttonText && buttonPath)" class="text-container">
        <b-row class="text-content">
          <b-col>
            <prismic-rich-text v-if="title" :field="title" class="title"></prismic-rich-text>
            <prismic-rich-text v-if="text" :field="text" class="text"></prismic-rich-text>
            <Button v-if="buttonText && buttonPath" :to="path" :blank="blank" @click="showModal">
              {{ buttonText }}
            </Button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: false,
      buttonPath: '',
      buttonText: '',
      imageAlt: '',
      imageUrl: '',
      openModal: false,
      text: '',
      title: ''
    };
  },
  computed: {
    blank() {
      return !this.openModal ? this.buttonBlank : false;
    },
    path() {
      return !this.openModal ? this.buttonPath : '';
    }
  },
  created() {
    const { primary } = this.slice;

    this.buttonBlank = primary.button_blank;
    this.buttonPath = primary.button_path[0]?.text;
    this.buttonText = primary.button_text[0]?.text;
    this.imageAlt = primary.image.alt;
    this.imageUrl = primary.image.url;
    this.openModal = primary.open_modal;
    this.text = primary.text[0]?.text ? primary.text : '';
    this.title = primary.title1[0]?.text ? primary.title1 : '';
  },
  methods: {
    showModal() {
      if (this.openModal) {
        this.$bvModal.show(this.buttonPath);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.title {
  text-align: left;
  font-size: 32px;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  padding-bottom: 20px;
}

.text {
  text-align: left;
  font-size: 16px;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  padding-bottom: 20px;
}

.text-container {
  display: flex;
  align-items: center;
  @include lg {
    flex-basis: auto;
  }
}

.text-content {
  padding: 20px;
}
</style>
